import { createAction } from 'redux-actions';

// action types
export const GLOBAL_TEAM_CACHED_RECEIVED = 'GLOBAL_TEAM_CACHED_RECEIVED';

// actions
export const cacheGlobalTeams = createAction(GLOBAL_TEAM_CACHED_RECEIVED);
